// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1m4fN","notes":"Notes_notes__YYjb9","note":"Notes_note__1ixUc","markdown":"Notes_markdown__1caOd"};